/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { Text, Pane, Flex, Button, Label, PortalOverlay, Selector, Toast } from '@leverege/ui-elements';
// import I18N from '@leverege/i18n'
import { GlobalState } from '@leverege/ui-redux';
import classes from './SelectLocationClasses.css';

// const { t } = I18N.ns( 'recovrGeneric.ownershipTransfer' )
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function SelectLocationView(props) {
  const {
    onClose,
    parentIncomingTransfer,
    setFlowStep,
    locationId,
    setLocationId
  } = props;
  const systemId = parentIncomingTransfer.systemId;

  // const uiName = process.env.UI_NAME
  // const assetIndustryName = t( `assetIndustryName.${uiName}`, 'Asset' )

  const [userLocationValues, setUserLocationValues] = useState([]);
  useEffect(() => {
    GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      try {
        const userCompaniesPrm = api.interface(systemId, 'company').list();
        const userLocationsPrm = api.interface(systemId, 'location').list();
        const [userCompaniesResponse, userLocationsResponse] = await Promise.all([userCompaniesPrm, userLocationsPrm]);
        const locationValuesObj = {};
        userLocationsResponse.items.forEach(location => {
          const id = location?.id;
          locationValuesObj[id] = {
            name: location?.name,
            value: location?.id
          };
        });
        const companyLocationPromises = userCompaniesResponse.items.map(({
          id: companyId
        }) => {
          return api.interface(systemId, 'company').obj(companyId).grp('locations').list();
        });
        const companyLocationResponses = await Promise.all(companyLocationPromises);
        const companyLocations = [];
        companyLocationResponses.forEach(resp => companyLocations.push(...resp.items));
        companyLocations.map(location => {
          const id = location?.id;
          locationValuesObj[id] = {
            name: location?.name,
            value: location?.id
          };
          return {
            name: location?.name,
            value: location?.id
          };
        });
        const locationValues = Object.values(locationValuesObj);
        setUserLocationValues(locationValues);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log({
          err: error
        });
      }
    });
  });
  const selectorRenderer = (value, selectorLabel) => {
    return /*#__PURE__*/_jsxs(Text, {
      style: {
        paddingLeft: '8px'
      },
      children: [" ", selectorLabel, " "]
    });
  };
  const onSubmit = evt => {
    try {
      setFlowStep('enableDataSharing');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log({
        err
      });
      Toast.error('Error accepting Transfer');
      onClose(evt);
    }
  };
  const iconBackgroundStyle = {
    height: '24px',
    width: '24px',
    borderRadius: '2px',
    backgroundColor: '#F0F6FF',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  };
  const iconStyle = {
    color: '#1646C5',
    position: 'absolute',
    align: 'center'
  };
  const renderDialog = () => /*#__PURE__*/_jsxs(Pane, {
    variant: "editorDialog",
    className: classes.dialog,
    children: [/*#__PURE__*/_jsxs(Flex, {
      className: classes.dialogHeader,
      justify: "space-between",
      children: [/*#__PURE__*/_jsx(Text, {
        style: {
          fontWeight: 'bold'
        },
        icon: /*#__PURE__*/_jsx(Flex, {
          style: {
            ...iconBackgroundStyle
          },
          children: /*#__PURE__*/_jsx("img", {
            style: {
              ...iconStyle
            },
            alt: "Transfer Icon",
            src: "https://storage.googleapis.com/prd-generic-kudelski-ui-assets/Screen%20Icons/screen-transfers-blue.svg"
          })
        }),
        children: "Accept Transfer"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "closeWindow",
        icon: "fa fa-remove",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(Pane, {
      className: classes.dialogBody,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "col",
        justify: "space-between",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          style: {
            lineHeight: '26px',
            fontSize: '16px'
          },
          children: "Select which location you would like the items to be moved to."
        }), /*#__PURE__*/_jsx(Label, {
          style: {
            paddingTop: '16px',
            paddingBottom: '4px',
            size: '13px'
          },
          children: " Select Transfer Location "
        }), /*#__PURE__*/_jsx(Selector, {
          className: classes.selector,
          value: locationId,
          targetAttachment: "bottom right",
          checkStyle: "toggle",
          onChange: data => {
            setLocationId(data.value);
          },
          renderer: selectorRenderer,
          popupStyle: {
            height: '304px'
          },
          showFilter: true,
          values: userLocationValues
        })]
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowL",
      className: classes.dialogFooter,
      justify: "flex-end",
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        className: classes.button,
        onClick: onClose,
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        disabled: !locationId,
        variant: "submit",
        style: {
          width: '120px'
        },
        onClick: onSubmit,
        children: " Next "
      })]
    })]
  });
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: "center",
    show: true,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    children: renderDialog()
  });
}